// Client-side backstop for slugs that bypass the server's visit URL middleware.
import {
  CONSULTATION_TYPE_ABBREVIATION_GENERALIZED_ANXIETY,
  CONSULTATION_TYPE_ABBREVIATION_GENERALIZED_ANXIETY_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA,
  CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
  CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
  CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON,
} from "~/shared/sharedConstants.js";
import generalizedAnxietyFollowUp from "~medical/generalizedAnxietyFollowUp.js";
import insomniaFollowUpTrial from "~medical/insomnia-follow-up-trial.js";
import insomniaInitial from "~medical/insomnia-initial.js";
import performanceAnxietyFollowUp from "~medical/performanceAnxietyFollowUp.js";
import performanceAnxietyInitial from "~medical/performanceAnxietyInitial.js";
import scopolamineAddon from "~medical/scopolamine-addon.js";

// One registry for validation and selection. Keep factories so questionnaires
// read the current checkout state on every lookup.
const questionnaireFactories = new Map([
  [
    CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY,
    performanceAnxietyInitial,
  ],
  [
    CONSULTATION_TYPE_ABBREVIATION_PERFORMANCE_ANXIETY_FOLLOW_UP,
    performanceAnxietyFollowUp,
  ],
  // GA initial shares PA initial until it has its own questionnaire.
  [
    CONSULTATION_TYPE_ABBREVIATION_GENERALIZED_ANXIETY,
    performanceAnxietyInitial,
  ],
  [
    CONSULTATION_TYPE_ABBREVIATION_GENERALIZED_ANXIETY_FOLLOW_UP,
    generalizedAnxietyFollowUp,
  ],
  [CONSULTATION_TYPE_ABBREVIATION_INSOMNIA, insomniaInitial],
  [CONSULTATION_TYPE_ABBREVIATION_INSOMNIA_FOLLOW_UP, insomniaFollowUpTrial],
  [CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON, scopolamineAddon],
]);

// Where a URL nobody minted lands: the start of the initial funnel. Mirrors the
// server's choice for an unknown slug.
export const VISITS_FUNNEL_START_PATH = "/visits/pac/signup";

export function isQuestionnaireConsultationType(consultationType) {
  return questionnaireFactories.has(consultationType);
}

export function getConsultationQuestionnaire(
  consultationType,
  checkoutSessionID,
) {
  return questionnaireFactories.get(consultationType)?.(checkoutSessionID);
}

// Keeps the query string so utm / Customer.io attribution survives the bounce.
export function funnelStartURL(search = "") {
  const qs = search.startsWith("?") ? search.slice(1) : search;
  return qs ? `${VISITS_FUNNEL_START_PATH}?${qs}` : VISITS_FUNNEL_START_PATH;
}

// Replace the bad URL so the back button cannot replay it.
export function redirectToFunnelStart() {
  window.location.replace(funnelStartURL(window.location.search));
}
